import fetchApi from '../helpers/fetch-api';
import formatedData from '../helpers/formatedData';
import renderStars from '../helpers/renderStars';
import createSlug from '../helpers/createSlug';

const blockDoctorsNearby = () => {
	let defaultStateId = 7; // mazowieckie
	const locationData = JSON.parse(localStorage.getItem('locationData'));
	if (locationData) defaultStateId = locationData.provinceId;

	// detects changes
	const radioInputs = document.querySelectorAll('.js-radio-input-dotors');
	// eslint-disable-next-line no-undef
	const urlBaseAppDetails = appVariables.apiDetailsDoctors;

	const fetchDoctorReview = (idDoctor) => {
		let reviewBox = '';
		const urlGet = 'sortOrder=DESC&orderBy=createAt&status=ACCEPTED&context=POSITIVE';
		// eslint-disable-next-line no-undef
		fetchApi('GET', `${appVariables.apiUrl}/api/v1/doctor/${idDoctor}/reviews?${urlGet}`).then((response) => {
			if (response.data) {
				if (response.data.length > 0) {
					const revData = response.data[0];

					if (revData) {
						const { content, createdAt, name } = revData;
						const newFormatedDate = formatedData(createdAt);
						let newContent = '';

						if (content.length > 200) {
							newContent = `${content.substring(0, 200)}...`;
						} else {
							newContent = content;
						}

						const displayName = name.length > 0 ? name : 'Pacjent';

						reviewBox += "<div class='c-review-simple'>";
						reviewBox += "<div class='c-review-simple__header'>";
						reviewBox += `<span class='c-review-simple__header-name'>${displayName}</span>`;
						reviewBox += `<span class='c-review-simple__header-date'>${newFormatedDate}</span>`;
						reviewBox += '</div>';
						reviewBox += `<div class='c-review-simple__content'>${newContent}</div>`;
						reviewBox += '</div>';
					}

					if (reviewBox) {
						const renderedRev = document.getElementById(`rev-${idDoctor}`);
						if (renderedRev) renderedRev.innerHTML = reviewBox;
					}
				}
			}
		});
	};

	// render box
	const renderBoxDoctor = (doctor) => {
		let doctorsBox = '';

		const { firstName, lastName, degree, id, specializations, totalReviews, countReviews, avatar } = doctor;
		const slugNameDoctor = createSlug(`${degree.shortcut + firstName}-${lastName}`);

		// eslint-disable-next-line no-undef
		let doctorImg = `${appVariables.assetsUrl}doctor-test.png`;

		if (avatar) {
			if (avatar.accessUrl) doctorImg = avatar.accessUrl;
		}

		const specDisplay =
			specializations[0] && 'searchKeyword' in specializations[0] ? specializations[0].searchKeyword : '';
		const iconOk =
			'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="4" fill="#28DFAE"/><path d="M12.6667 10H11.9167V10.75H12.6667V10ZM16 11.25C15.5858 11.25 15.25 11.5858 15.25 12C15.25 12.4142 15.5858 12.75 16 12.75V11.25ZM15.3333 13.25C14.9191 13.25 14.5833 13.5858 14.5833 14C14.5833 14.4142 14.9191 14.75 15.3333 14.75V13.25ZM14.6667 15.25C14.2525 15.25 13.9167 15.5858 13.9167 16C13.9167 16.4142 14.2525 16.75 14.6667 16.75V15.25ZM10.4215 6.81725L9.70312 6.60174L10.4215 6.81725ZM12.6667 10.75H17V9.25H12.6667V10.75ZM17 11.25H16V12.75H17V11.25ZM13.4167 10V7.14677H11.9167V10H13.4167ZM9.70312 6.60174L7.9483 12.4512L9.38504 12.8822L11.1399 7.03276L9.70312 6.60174ZM16 12.75H16.3333V11.25H16V12.75ZM16.3333 13.25H15.3333V14.75H16.3333V13.25ZM15.3333 14.75H15.6667V13.25H15.3333V14.75ZM15.6667 15.25H14.6667V16.75H15.6667V15.25ZM14.6667 16.75H15V15.25H14.6667V16.75ZM15 17.25H8.66667V18.75H15V17.25ZM8.66667 17.25H6.66667V18.75H8.66667V17.25ZM6.75 17.3333V13.3333H5.25V17.3333H6.75ZM6.66667 13.4167H8.66667V11.9167H6.66667V13.4167ZM7.91667 12.6667V18H9.41667V12.6667H7.91667ZM6.75 13.3333C6.75 13.3794 6.71269 13.4167 6.66667 13.4167V11.9167C5.88426 11.9167 5.25 12.5509 5.25 13.3333H6.75ZM15.25 17C15.25 17.1381 15.1381 17.25 15 17.25V18.75C15.9665 18.75 16.75 17.9665 16.75 17H15.25ZM15.9167 15C15.9167 15.1381 15.8047 15.25 15.6667 15.25V16.75C16.6332 16.75 17.4167 15.9665 17.4167 15H15.9167ZM15.6667 14.75C15.8047 14.75 15.9167 14.8619 15.9167 15H17.4167C17.4167 14.0335 16.6332 13.25 15.6667 13.25V14.75ZM16.5833 13C16.5833 13.1381 16.4714 13.25 16.3333 13.25V14.75C17.2998 14.75 18.0833 13.9665 18.0833 13H16.5833ZM6.66667 17.25C6.71269 17.25 6.75 17.2873 6.75 17.3333H5.25C5.25 18.1157 5.88426 18.75 6.66667 18.75V17.25ZM11.5199 5.25C10.6823 5.25 9.94381 5.79943 9.70312 6.60174L11.1399 7.03276C11.1902 6.86493 11.3447 6.75 11.5199 6.75V5.25ZM13.4167 7.14677C13.4167 6.09921 12.5675 5.25 11.5199 5.25V6.75C11.739 6.75 11.9167 6.92764 11.9167 7.14677H13.4167ZM16.3333 12.75C16.4714 12.75 16.5833 12.8619 16.5833 13H18.0833C18.0833 12.0335 17.2998 11.25 16.3333 11.25V12.75ZM15 16.75C15.1381 16.75 15.25 16.8619 15.25 17H16.75C16.75 16.0335 15.9665 15.25 15 15.25V16.75ZM17.25 11C17.25 11.1381 17.1381 11.25 17 11.25V12.75C17.9665 12.75 18.75 11.9665 18.75 11H17.25ZM17 10.75C17.1381 10.75 17.25 10.8619 17.25 11H18.75C18.75 10.0335 17.9665 9.25 17 9.25V10.75Z" fill="white"/></svg>';
		const iconArrow =
			'<svg class="c-link__icon" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6H13M13 6L8 1M13 6L8 11" stroke="#003B50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		doctorsBox += "<div class='col-lg-4 col-md-6 b-doctors-nearby__single-col'>";
		doctorsBox += "<div class='c-box-single-doctor'>";
		doctorsBox += "<div class='c-box-single-doctor__img-wrapper'>";
		doctorsBox += `<img class='c-box-single-doctor__img' src='${doctorImg}' alt='${firstName}'>`;
		doctorsBox += '</div>';
		doctorsBox += "<div class='c-box-single-doctor__header'>";
		doctorsBox += `<h4 class='c-box-single-doctor__name'> <span class='c-box-single-doctor__icon-ok'>${iconOk}</span> ${degree.shortcut} ${firstName} ${lastName} </h4>`;
		doctorsBox += `<div class='c-box-single-doctor__specialization'>${specDisplay}</div>`;
		doctorsBox += '</div>';
		doctorsBox += "<div class='c-box-single-doctor__rating c-rating-value'>";
		doctorsBox += `<div class='c-rating-value__stars'>${renderStars(totalReviews)}</div>`;
		doctorsBox += `<div class='c-rating-value__rating'>${totalReviews.toFixed(2)} / 5</div>`;
		doctorsBox += `<div class='c-rating-value__rating-count'>(${countReviews} ocen)</div>`;
		doctorsBox += '</div>';
		doctorsBox += "<div class='c-box-single-doctor__link-wrapp'>";
		doctorsBox += `<a class='c-link c-link--arrow' href='${urlBaseAppDetails}/${slugNameDoctor}/${id}'><span class='c-link__text'>Zobacz profil lekarza</span> ${iconArrow}</a>`;
		doctorsBox += '</div>';
		doctorsBox += `<div class='c-box-single-doctor__review-wrapper js-review-doctor' id="rev-${id}"> </div>`;
		doctorsBox += '</div>';
		doctorsBox += '</div>';

		return doctorsBox;
	};

	const fetchDataReview = (orderBy, provId = '') => {
		// eslint-disable-next-line no-undef
		let doctorsBoxes = '';
		if (provId.length > 0) defaultStateId = provId;
		const wrapper = document.querySelector('.js-doctors-nearby-result');
		const parameters = `orderBy=${orderBy}&provinceId=${defaultStateId}&limit=3`;

		// eslint-disable-next-line no-undef
		fetchApi('GET', `${appVariables.apiUrl}/api/v1/doctor/?${parameters}`).then((response) => {
			if (response.data) {
				if (response.data.length > 0) {
					response.data.forEach((doctor) => {
						doctorsBoxes += renderBoxDoctor(doctor);
						fetchDoctorReview(doctor.id);
					});

					wrapper.innerHTML = doctorsBoxes;
				}
			}
		});
	};

	const provinceInput = document.querySelector('.js-custom-select #province');

	if (radioInputs) {
		if (provinceInput) {
			provinceInput.addEventListener('change', () => {
				const { selectedIndex } = provinceInput;
				const provinceId = provinceInput.options[selectedIndex].value;

				radioInputs.forEach((input) => {
					if (input.checked) {
						const valinput = input.value;
						if (valinput) fetchDataReview(valinput, provinceId);
					}
				});
			});
		}

		radioInputs.forEach((input) => {
			// init action url
			if (input.checked) {
				const valinput = input.value;
				if (valinput) fetchDataReview(valinput);
			}

			input.addEventListener('change', (e) => {
				const { value } = e.currentTarget;
				const provinceInput2 = document.querySelector('.js-custom-select #province');
				const { selectedIndex } = provinceInput2;
				const provinceId = provinceInput2.options[selectedIndex].value;

				if (value && provinceId) fetchDataReview(value, provinceId);
				else if (value) fetchDataReview(value);
			});
		});
	}
};

export default blockDoctorsNearby;
